module.exports = __webpack_public_path__ + "img/blue-chevron-right.e0f121b4.svg";